// extracted by mini-css-extract-plugin
export default {"itemTitle":"styles_itemTitle__vm4CC","title":"styles_title__QRF+P","subtitle":"styles_subtitle__rezq8"};